export default __webpack_public_path__ + "media/images/icons/arrow-next-1cded95eab873a6d51f36ff8fd7357a7.svg";